/**
 * Utility to clone objects.
 */
export class CloneUtil {

    public static clone<T>(object: T): T {
        return JSON.parse(JSON.stringify(object));
    }
}
